import { DataManager } from '@syncfusion/ej2-data';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { PaymentFormType } from '../payment-form/payment-form-type';
import { DateTime } from 'luxon';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { PaymentReportService } from '../payment-report.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { Currency, DateRangeParameterDTO, ParkingSessionPaymentState, PaymentReportParameterDTO } from 'src/app/base/models/models.swagger.generated';
import { SaveOptions } from '../../../reports-footer/save-options';
import { reportsRoute } from 'src/app/core/routing/route-names';
import { ClientService } from 'src/app/base/services/client/client.service';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentFormComponent } from '../payment-form/payment-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-payment-report',
    templateUrl: './payment-report.component.html',
    styleUrls: ['./payment-report.component.scss'],
    imports: [TitleBarComponent, PaymentFormComponent, GridModule, ReportsFooterComponent, TranslateModule]
})
export class PaymentReportComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public data: DataManager;
  public filterForm: PaymentFormType = this.fb.group({
    startDate: [DateTime.now().startOf('month').toJSDate()],
    endDate: [DateTime.now().endOf('month').toJSDate()],
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();

  constructor(private fb: FormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private paymentReportService: PaymentReportService,
              private clientService: ClientService) { }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.paymentReportService, this.spinnerService),
    });
    this.searchReports();
  }

  public searchReports(): void {
    if (this.filterForm.controls.startDate.value && this.filterForm.controls.endDate.value) {
      this.paymentReportService.parameters = this.createReportParametersFromFilters();
      try {
        this.grid?.refresh();
      } catch (e) {
        // Ignore error when grid is in transition state
      }
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();

    const reportParameterDTO = this.createReportParametersFromFilters();
    this.paymentReportService.exportReport(reportParameterDTO, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  public formatCurrency(type: Currency): string {
    return 'i18n.shared.currencies.' + Currency[type];
  }

  public formatPaymentState(state: ParkingSessionPaymentState): string {
    return 'i18n.shared.parkingSessionPaymentStates.' + ParkingSessionPaymentState[state];
  }

  private createReportParametersFromFilters(): PaymentReportParameterDTO {
    return new PaymentReportParameterDTO({
      dateRange: new DateRangeParameterDTO({
        startDate: DateTime.fromJSDate(this.filterForm.controls.startDate.value).startOf('day').toFormat('yyyy-MM-dd'),
        endDate: DateTime.fromJSDate(this.filterForm.controls.endDate.value).startOf('day').toFormat('yyyy-MM-dd'),
      }),
      clientId: this.clientService.selectedClient?.id
    });
  }
}
